var _style, _g, _ellipse, _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixerBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000127016840984459794320000013331435541868175533_",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.mixerBag-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:10;}\r\n\t.mixerBag-st1{fill:none;stroke:currentColor;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "mixerBag-st0",
    d: "M73.3,59.4V21L40,1.7L6.7,21v38.4c0.5,0.8,11.9,19.2,33.7,19C61.7,78.2,72.7,60.4,73.3,59.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "mixerBag-st1",
    d: "M40,39.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "mixerBag-st1",
    x1: 6.7,
    y1: 21,
    x2: 39.9,
    y2: 40.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "mixerBag-st1",
    x1: 73.2,
    y1: 21,
    x2: 39.9,
    y2: 40.2
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "mixerBag-st1",
    cx: 40,
    cy: 21.9,
    rx: 8,
    ry: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mixerBag-st0",
    d: "M50.2,56.4c-2,0-7.6,0.9-10.2,2.2c-2.6-1.3-8.2-2.2-10.2-2.2c-2.6,0-4.8,1.6-4.8,3.6c0,2,2.1,3.6,4.8,3.6 c2,0,7.6-0.9,10.2-2.2c2.6,1.3,8.2,2.2,10.2,2.2c2.6,0,4.8-1.6,4.8-3.6C54.9,58,52.8,56.4,50.2,56.4z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "mixerBag-st1",
    x1: 40,
    y1: 61.4,
    x2: 40,
    y2: 12.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixerBag);
export default __webpack_public_path__ + "static/media/mixerBag.e5ac94f797770d617bdce340e3d0d5cf.svg";
export { ForwardRef as ReactComponent };